"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelCase;

function camelCase(str) {
  return str.replace(/[-_]+/g, ' ').replace(/[^\w\s]/g, '').replace(/ (.)/g, function ($1) {
    return $1.toUpperCase();
  }).replace(/ /g, '').replace(/^./g, function ($1) {
    return $1.toLowerCase();
  });
}